import apiRoutes from "./apiRoutes";
import { BaseCrudService } from "./baseCrudService";

export interface PrepaymentConfirmationData {
  reference: string;
  amount: string;
  account_owner: string;
  iban: string;
  bic: string;
  bank: string;
}

export class PrepaymentService extends BaseCrudService {
  async getPrepaymentConfirmation(orderId: string) {
    return this.axiosInstance.get<PrepaymentConfirmationData>(
      apiRoutes.prepayment_confirmation,
      {
        params: { order_id: orderId },
      }
    );
  }
}
